<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Detalhes da auditoria</p>
        </div>

        <div class="muven-content">
            <Breadcrumb :items="breadcrumbList" class="mb-3"/>

            <Loading page v-if="loading" />            

            <div v-if="!loading">
                <!--<div class="btn-group mb-3">
                   <button type="button"                    
                        class="btn"
                        :class="{
                            'btn-secondary active': shouldShowAudit,
                            'btn-outline-secondary': !shouldShowAudit,
                        }"
                        @click="showAudit()">Passo a passo</button>

                    <button type="button" 
                        class="btn"
                        :class="{
                            'btn-secondary active': shouldShowFlow,
                            'btn-outline-secondary': !shouldShowFlow,
                        }"
                        @click="showFlow()">Visualizar em fluxo</button>
                </div>-->

                <AuditInstanceCmp 
                    :audit="audit" 
                    :channel="channel"
                    v-show="shouldShowAudit"/>

                <AuditInstanceFlowCmp 
                    :audit-flow="auditFlow" 
                    v-if="shouldShowFlow" />
            </div>
        </div>
    </div>    
</template>

<script>
import BpmnJS from 'bpmn-js'
import AuditInstanceCmp from '@/audit/components/AuditInstanceCmp'
import AuditInstanceFlowCmp from '@/audit/components/AuditInstanceFlowCmp'
import { AuditInstanceFlowModel } from '@/audit/models/AuditInstanceFlowModel'
import auditService from '@/audit/services/AuditService'
import { AuditInstanceModel } from '@/audit/models/AuditInstanceModel'
import { ChannelModel } from '@/channel/models/ChannelModel'
import ChannelService from '@/channel/services/ChannelService'

export default {
    name: 'AuditInstanceWrapperView',    
    components: {
        AuditInstanceCmp,
        AuditInstanceFlowCmp,
    },
    data() {
        return {
            loading: true,
            shouldShowAudit: true,
            shouldShowFlow: false,
            audit: new AuditInstanceModel(),
            auditFlow: new AuditInstanceFlowModel(),            
            channel: new ChannelModel(),
            breadcrumbList: [
                {
                    id: 0,
                    description: 'Auditoria',
                    path: '/auditorias',
                },
                {
                    id: 1,
                    description: `Detalhes de #${this.$route.params.id}`,
                    path: '',
                },
            ],
        }
    },
    methods: {
        showAudit() {
            this.shouldShowAudit = true
            this.shouldShowFlow = false
        },
        showFlow() {
            this.shouldShowFlow = true
            this.shouldShowAudit = false
        },
    },
    async mounted() {
        try {
            [this.audit, this.auditFlow] = await Promise.all([
                auditService.getInstanceById(this.$route.params.id),
                // auditService.getInstanceFlowById(this.$route.params.id),
            ])

            if (this.audit.isFromAgent()) {
                this.channel = await ChannelService.getChannelById(this.audit.idChannel)
            }
        } catch(e) {
            this.$floatingAlert.error({
                message: e.message,
            })
        }

        this.loading = false
    },
}
</script>
